import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const InputContainer = styled.div`
  label {
    display: flex;
    font-size: 16px;
    line-height: 19px;
    font-weight: 700;
    color: #000;
    margin-bottom: 10px;
  }
  @media ${device.mobileS} {
    label {
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

export const InputWrapper = styled.div`
    width: 100%;
    position: relative;
    input{
        background-color: #fff;
        border: 1px #D0D0D0 solid;
        width: 100%;
        padding: 10px 16px;
        border-radius: 4px;
        font-family: 'Lato';
        font-size: 16px;
        color: #2F281E;
        outline: 0;
        ${p =>
          p.haserror &&
          `
            border-color: #FF7B41;
        `}
        @media ${device.mobileS} {
            border-radius: 2px;
        }
    }
    input.isError{
        border-color: #FF7B41;
    }
    ${p =>
      p.extrapadding &&
      `
        input{
            padding: 10px 16px 10px 100px;
        }
    `}
    .ic_eye{
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }
`;

export const FlagCont = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100px;
  display: flex;
  border-radius: 4px 0 0 4px;
  align-items: center;
  padding-left: 10px;
`;
export const Flag = styled.span`
  width: 23px;
  height: 17px;
  flex-shrink: 0;
  margin-right: 8px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const Code = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #000;
`;
